import {WmWoundLocation} from '../../interfaces/wound-management/wm-wound-location';

export class WmWoundLocationFactory {

  /**
   *
   * @param wmWoundLocation
   */
  public static getObject(wmWoundLocation: any): WmWoundLocation {
    return new class implements WmWoundLocation {
      code: number = wmWoundLocation.code;
      id: number = wmWoundLocation.id;
      name: string = wmWoundLocation.name;
      shortName: string = wmWoundLocation.short_name;
      diagramId: number = wmWoundLocation.diagram_id;
    };
  }

  /**
   *
   * @param wmWoundLocations
   */
  public static fromArray(wmWoundLocations: any[]): WmWoundLocation[] {
    return wmWoundLocations.map(_wmWoundLocation => WmWoundLocationFactory.getObject(_wmWoundLocation));
  }

}
